<template>
	<div>
		<h1 class="desktop-salutation">{{$t('common.welcome')}}{{nickName}}！</h1>
		<div class="portal-navigation site-row">
			<ul class="site-nav-tabs nav nav-tabs">
				<li class="nav-list" :class="subMenuIndex == 2 ? 'active' : ''">
					<a href="javascript:void(0)" @click="openPage('order')">{{$t('common.myorder')}}</a>
				</li>
				<li class="nav-list " :class="subMenuIndex == 1 ? 'active' : ''">
					<a href="javascript:void(0)" @click="openPage('user')">{{$t('common.myaccount')}}</a>
				</li>
			</ul>
		</div>
		<div class="mobile-portal-navigation" style="display: none;">
			<div class="tab-group-portal">
				<div class="mobile-nav-title">
					<span>{{$t('common.account')}} </span>
					<img src="../assets/images/right.png" class="right-icon"/>
				</div>
				<div class="site-dropdown dropdown mobile-nav-dropdown" :class="menuShow ? 'open' : ''">
					<button class="btn dropdown-toggle" @click="changeMenu">
						<span class="pull-left selected-tab hide dropdown-toggle-label " :class="subMenuIndex == 2 ? 'show' : 'hide'">{{$t('common.myorder')}}</span>
						<span class="pull-left selected-tab hide dropdown-toggle-label " :class="subMenuIndex == 1 ? 'show' : 'hide'">{{$t('common.myaccount')}}</span>
						<img  src="../assets/images/arrow-down.png" class="down-icon"/>
					</button>
					<div class="dropdown-backdrop" v-if="menuShow" @click="changeMenu"></div>
					<ul class="dropdown-menu">
						<li class="active-tab">
							<a href="javascript:void(0)" @click="openPage('order')">
								<span class="dropdown-link-text">{{$t('common.myorder')}}</span>
							</a>
						</li>
						<li class="active-tab">
							<a href="javascript:void(0)" @click="openPage('user')">
								<span class="dropdown-link-text">{{$t('common.myaccount')}}</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="mobile-salutation">{{$t('common.welcome')}}先生！</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			subMenuIndex:{
				type: Number,
				default: 1,
			},
		},
		data() {
			return {
				isMobile:false,
				menuShow:false,
				nickName:''
			};
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.nickName = localStorage.getItem('nickname') || ''
		},
		methods: {
			changeMenu(){
				this.menuShow = !this.menuShow
			}
		}
	}
</script>

<style scoped>
	.portal-navigation .nav-tabs .active a:hover, .portal-navigation .nav-tabs .active a:focus {
		 color: #555;
		 border-left: none;
		 border-top: none;
		 border-right: none;
		 border-bottom: 3px solid #008338;
	}
</style>